import React, { useEffect, useState } from "react";
import { Accordion, Button, Col, Container, Form, Row } from "react-bootstrap";
// css
import styles from "./GroupDetail.module.scss";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";
import TableLayout from "components/TableLayout";
import { CommonToolTip, CstmPagination } from "components/Common/Common";
import AddNewMemberModal from "components/Modals/AddNewMember";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useGetGroupDetailsQuery, useRemoveGroupMemberMutation, useUpdateGroupMutation } from "store/services/group";
import { convertToMomentDate, errorMessageToast, successMessageToast, userFullName } from "helpers/common";
import { CLIENT_REPORT_TYPES, CLIENT_TYPE, REPORT_IDS } from "config/constants";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import LoadingOverlay from "components/shared/LoadingOverlay";

// img
const GroupDetail = () => {

  const { id: groupId } = useParams();
  const navigate = useNavigate();

  const { data: groupDetails, isLoading, isFetching } = useGetGroupDetailsQuery(groupId);
  const totalMembers = Math.ceil(groupDetails?.members?.length / 5);

  const [removeGroupMember, { isLoading: removeGroupMemberLoading }] = useRemoveGroupMemberMutation();
  const [updateGroup, { isLoading: updateGroupLoading }] = useUpdateGroupMutation();

  const [currentMemberPage, setCurrentMemberPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [addMemberModal, setAddMemberModal] = useState();
  const [startSession, setStartSession] = useState();
  const [members, setMembers] = useState([]);
  const [membersList, setMembersList] = useState([]);

  const handleMemberPageChange = (page) => {
    setCurrentMemberPage(page);

    const indexFromSlice = (page - 1) * 5;
    setMembersList(groupDetails?.members?.slice(indexFromSlice, indexFromSlice + 5));
  };

  const column = [
    {
      head: "Last Name ",
      accessor: "lastname",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item?.user?.lastname}</h6>
      ),
    },
    {
      head: "First Name ",
      accessor: "firstname",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item?.user?.firstname}</h6>
      ),
    },
    {
      head: "DOB",
      accessor: "SchoolName",
      isComponent: true,
      component: (item, ind) => <p className="m-0 ">{convertToMomentDate(item?.user?.client_detail?.dob)}</p>,
    },
    {
      head: "Grade",
      accessor: "TherapistName",
      component: (item, ind) => <p className="m-0 ">{item?.user?.client_detail?.grade || "--"}</p>,
    },
    {
      head: "Gender",
      accessor: "StartDate",
      component: (item, ind) => <p className="m-0 text-capitalize">{item?.user?.client_detail?.gender || "--"}</p>,
    },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">

          <Button
            onClick={() => {

              const assessmentId = REPORT_IDS["INDIVIDUAL_SESSION_REPORT"];
              const report = CLIENT_REPORT_TYPES[assessmentId];
              navigate(generatePath(report.path, {
                assessmentId: assessmentId,
                clientId: item?.user?.id,
                clientType: groupDetails?.group_type
              }));
            }}
            className="d-flex rounded-3 align-items-center justify-content-center commonBtn"
            style={{
              background: "#41A2A8",
              borderColor: "#41A2A8",
            }}
          >
            Start Session
          </Button>
          <CommonToolTip
            text={"Delete"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={() => {

                if (!isFetching && !removeGroupMemberLoading) {
                  setShowModal(true);
                  setCurrentEntry(item);
                };
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
              >
                <circle cx="13.5" cy="13.5" r="13.5" fill="#FFE3E5" />
                <mask
                  id="mask0_26_18856"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="5"
                  y="5"
                  width="18"
                  height="18"
                >
                  <rect x="5" y="5" width="18" height="18" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_26_18856)">
                  <path
                    d="M10.4808 20.3753C10.1068 20.3753 9.78731 20.2429 9.52231 19.978C9.25744 19.713 9.125 19.3935 9.125 19.0195V9.50029H8.375V8.37529H11.75V7.71191H16.25V8.37529H19.625V9.50029H18.875V19.0195C18.875 19.3984 18.7438 19.719 18.4813 19.9815C18.2188 20.244 17.8981 20.3753 17.5192 20.3753H10.4808ZM17.75 9.50029H10.25V19.0195C10.25 19.0869 10.2716 19.1422 10.3149 19.1854C10.3581 19.2287 10.4134 19.2503 10.4808 19.2503H17.5192C17.5769 19.2503 17.6298 19.2262 17.6778 19.1781C17.7259 19.1301 17.75 19.0772 17.75 19.0195V9.50029ZM12.053 17.7503H13.1778V11.0003H12.053V17.7503ZM14.8222 17.7503H15.947V11.0003H14.8222V17.7503Z"
                    fill="#071E3E"
                  />
                </g>
              </svg>
            </Button>}
          />

        </div>
      ),
    },
  ];

  const newColumn = [
    {
      accessor: "GroupName",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item.GroupName}</h6>
      ),
    },

    {
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <Button
            // onClick={handleConfirmation}
            className="p-2 shadow-lg rounded-circle"
            variant="transparent"
            type="button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={19}
              height={19}
              viewBox="0 0 19 19"
              fill="none"
              style={{ background: "white", borderRadius: "0", border: "0" }}
            >
              <path
                d="M14.5488 9.07964C14.134 9.07964 13.7988 9.4157 13.7988 9.82959V15.8296C13.7988 16.2429 13.4628 16.5796 13.0489 16.5796H2.54883C2.13479 16.5796 1.79887 16.2429 1.79887 15.8296V5.32959C1.79887 4.91636 2.13479 4.57964 2.54883 4.57964H8.54887C8.96361 4.57964 9.29883 4.24361 9.29883 3.82968C9.29883 3.41565 8.96361 3.07959 8.54887 3.07959H2.54883C1.30834 3.07959 0.298828 4.0891 0.298828 5.32959V15.8296C0.298828 17.0702 1.30834 18.0796 2.54883 18.0796H13.0489C14.2894 18.0796 15.2989 17.0702 15.2989 15.8296V9.82959C15.2989 9.41489 14.9635 9.07964 14.5488 9.07964Z"
                fill="#818181"
              />
              <path
                d="M7.33078 8.39625C7.27866 8.44861 7.24295 8.51506 7.22805 8.58743L6.69783 11.2395C6.67311 11.3624 6.7121 11.4892 6.80055 11.5784C6.83546 11.6132 6.87688 11.6408 6.92245 11.6596C6.96802 11.6784 7.01684 11.688 7.06612 11.6879C7.09003 11.6879 7.11489 11.6857 7.1396 11.6805L9.79087 11.1503C9.86435 11.1352 9.93108 11.1 9.98286 11.0474L15.9169 5.11339L13.2656 2.46226L7.33078 8.39625ZM17.7498 0.628542C17.0186 -0.102743 15.8291 -0.102743 15.0985 0.628542L14.0606 1.66646L16.7118 4.31773L17.7498 3.27967C18.1038 2.92646 18.2988 2.4554 18.2988 1.95442C18.2988 1.45345 18.1038 0.982425 17.7498 0.628542Z"
                fill="#818181"
              />
            </svg>
          </Button>
        </div>
      ),
    },
    {
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <Button
            // onClick={handleConfirmation}
            className="p-2 shadow-lg rounded-circle"
            variant="transparent"
            type="button"
            style={{ background: "white", borderRadius: "0", border: "0" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={22}
              height={21}
              viewBox="0 0 22 21"
              fill="none"
            >
              <path
                d="M19.9384 5.51779C19.2154 4.79509 18.2965 4.3403 17.3017 4.20158C17.163 3.20683 16.708 2.28791 15.9853 1.56467C15.1065 0.686356 13.9387 0.202637 12.6967 0.202637H5.26641C4.02423 0.202637 2.85644 0.686355 1.97813 1.56485C1.09964 2.44316 0.615921 3.61113 0.615921 4.85331V12.2837C0.615921 13.5263 1.09964 14.6941 1.97795 15.572C2.70066 16.2949 3.61976 16.7499 4.61487 16.8884C4.75341 17.8835 5.20837 18.8026 5.93108 19.5252C6.80939 20.4036 7.97718 20.8874 9.21954 20.8874H16.65C17.8922 20.8874 19.0601 20.4036 19.9386 19.5252C20.8171 18.6467 21.3008 17.4789 21.3008 16.2369V8.80643C21.3006 7.56461 20.8169 6.39682 19.9384 5.51779ZM2.05342 12.2837V4.85331C2.05342 3.99494 2.38764 3.18814 2.99444 2.58116C3.29212 2.28188 3.64619 2.04461 4.03618 1.88309C4.42616 1.72156 4.8443 1.63898 5.26641 1.64014H12.6968C13.5549 1.64014 14.362 1.97436 14.969 2.58116C15.2683 2.87887 15.5056 3.23297 15.6671 3.62298C15.8287 4.01299 15.9113 4.43116 15.9102 4.85331V12.2837C15.9102 13.1418 15.576 13.9487 14.9692 14.5557C14.6714 14.855 14.3173 15.0923 13.9273 15.2539C13.5372 15.4154 13.119 15.498 12.6968 15.4969H5.26641C4.40823 15.4969 3.60125 15.1627 2.99444 14.5557C2.69517 14.258 2.45791 13.904 2.29638 13.514C2.13486 13.124 2.05228 12.7059 2.05342 12.2837ZM19.8631 16.2369C19.8631 17.0949 19.5289 17.9019 18.9221 18.5088C18.6244 18.8082 18.2703 19.0455 17.8802 19.207C17.4902 19.3686 17.072 19.4512 16.6498 19.45H9.21954C8.36135 19.45 7.55437 19.1158 6.94757 18.5088C6.51514 18.0774 6.21561 17.531 6.08453 16.9344H12.6967C13.9389 16.9344 15.1068 16.4507 15.9853 15.5722C16.8638 14.6937 17.3475 13.5259 17.3475 12.2839V5.67161C17.9441 5.80261 18.4905 6.10209 18.9219 6.53446C19.2212 6.83217 19.4585 7.18628 19.6201 7.57629C19.7816 7.9663 19.8643 8.38447 19.8631 8.80661V16.2369Z"
                fill="#818181"
              />
              <path
                d="M6.00546 9.28751H8.26288V11.5449C8.26288 11.7355 8.3386 11.9184 8.47339 12.0532C8.60819 12.1879 8.791 12.2637 8.98163 12.2637C9.17225 12.2637 9.35507 12.1879 9.48986 12.0532C9.62465 11.9184 9.70038 11.7355 9.70038 11.5449V9.28751H11.9578C12.1484 9.28751 12.3312 9.21178 12.466 9.07699C12.6008 8.9422 12.6765 8.75938 12.6765 8.56876C12.6765 8.37813 12.6008 8.19532 12.466 8.06052C12.3312 7.92573 12.1484 7.85001 11.9578 7.85001H9.70038V5.59277C9.70038 5.40215 9.62465 5.21933 9.48986 5.08454C9.35507 4.94975 9.17225 4.87402 8.98163 4.87402C8.791 4.87402 8.60819 4.94975 8.47339 5.08454C8.3386 5.21933 8.26288 5.40215 8.26288 5.59277V7.85001H6.00546C5.81484 7.85001 5.63202 7.92573 5.49723 8.06052C5.36244 8.19532 5.28671 8.37813 5.28671 8.56876C5.28671 8.75938 5.36244 8.9422 5.49723 9.07699C5.63202 9.21178 5.81484 9.28751 6.00546 9.28751Z"
                fill="#818181"
              />
            </svg>
          </Button>
        </div>
      ),
    },

    {
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <Button
            // onClick={handleConfirmation}
            className="p-2 rounded-circle "
            variant="transparent"
            type="button"
            style={{ background: "white", borderRadius: "0", border: "0" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="9"
              viewBox="0 0 15 9"
              fill="none"
            >
              <path
                d="M0.510416 0.894179C0.607253 0.79264 0.722461 0.712045 0.849398 0.657046C0.976335 0.602047 1.11249 0.57373 1.25 0.57373C1.38751 0.57373 1.52366 0.602047 1.6506 0.657046C1.77754 0.712045 1.89275 0.79264 1.98958 0.894179L6.76042 5.85585C6.85725 5.95738 6.97246 6.03798 7.0994 6.09298C7.22634 6.14798 7.36249 6.17629 7.5 6.17629C7.63751 6.17629 7.77366 6.14798 7.9006 6.09298C8.02754 6.03798 8.14275 5.95738 8.23958 5.85585L13.0104 0.894179C13.1073 0.79264 13.2225 0.712045 13.3494 0.657046C13.4763 0.602047 13.6125 0.57373 13.75 0.57373C13.8875 0.57373 14.0237 0.602047 14.1506 0.657046C14.2775 0.712045 14.3927 0.79264 14.4896 0.894179C14.6836 1.09715 14.7925 1.37173 14.7925 1.65793C14.7925 1.94413 14.6836 2.2187 14.4896 2.42168L9.70833 7.39418C9.12239 8.0028 8.32813 8.34465 7.5 8.34465C6.67187 8.34465 5.8776 8.0028 5.29167 7.39418L0.510416 2.42168C0.316405 2.2187 0.207505 1.94413 0.207505 1.65793C0.207505 1.37173 0.316405 1.09715 0.510416 0.894179Z"
                fill="#071E3E"
              />
            </svg>
          </Button>
        </div>
      ),
    },
  ];

  const data = [
    {
      GroupName: "John smith",
      SchoolName: "15/05/2024",
      TherapistName: "Grade 1",
      StartDate: "School",
      EndDate: "School town",
      status: "active",
    },
    {
      GroupName: "John smith",
      SchoolName: "15/05/2024",
      TherapistName: "Grade 1",
      StartDate: "School",
      EndDate: "School town",
      status: "active",
    },
  ];

  const handleDelete = async () => {
    try {

      setShowModal(false);

      const result = await removeGroupMember({ groupId, memberId: currentEntry?.user?.id });
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("error deleting group", err);
    };
  };

  const handleSubmit = async (values) => {
    try {

      if (!members?.length) return errorMessageToast("Please select atleast one member");

      let payload = {
        group_name: groupDetails?.group_name,
        start_date: groupDetails?.start_date,
        end_date: groupDetails?.end_date,
        group_type: groupDetails?.group_type,
        description: groupDetails?.description,
        group_image: groupDetails?.group_image,
        status: groupDetails?.status,
        members
      };

      const response = await updateGroup({ id: groupId, data: payload });
      if (!response?.error) {
        successMessageToast(response?.data?.message);
      }
    } catch (error) { console.log("Error updating group", error); };
  };

  useEffect(() => {

    if (!groupDetails) return;
    setMembersList(groupDetails?.members?.slice(0, 5));
    setMembers(groupDetails?.members?.map(i => i?.user?.id));

  }, [groupDetails]);

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={handleDelete}
        type="remove"
      />
      <AddNewMemberModal
        show={addMemberModal}
        setShow={setAddMemberModal}
        clientType={groupDetails?.group_type}
        setMembers={setMembers}
        handleSubmit={handleSubmit}
      />
      <section
        className={`${styles.GroupDetail} position-relative ClientDetail`}
      >
        {isLoading ? <LoadingIndicator /> : <Container fluid>
          <Row>
            {(isFetching || removeGroupMemberLoading || updateGroupLoading) && <LoadingOverlay />}
            <Col
              lg="6"
              className=""
            //   style={{ borderRight: "1px solid #3da0aa4f" }}
            >
              <Row>
                <Col lg="12" className="my-3">
                  <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                    <div className="left d-flex  gap-4">
                      <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                        <li className="">
                          <Link
                            className="themeBlue fw-sbold"
                            style={{ textDecoration: "underline" }}
                            to="/manage-group"
                          >
                            Group
                          </Link>
                        </li>
                        <li className="">
                          <h5 className="m-0 fw-bold themeBlue">/ Details</h5>
                        </li>
                      </ul>

                    </div>
                  </div>
                </Col>
                <Col lg="12" className="my-3">
                  <div className="top d-flex align-items-center gap-10">
                    <div
                      className="igmWrp flex-shrink-0 d-flex themeBlue fw-sbold align-items-center justify-content-center rounded-circle"
                      style={{ height: 35, width: 35, background: "#DBDBDB" }}
                    >
                      <div className="d-flex gap-2 align-items-center">
                        <img
                          src={groupDetails?.group_image || ""}
                          alt="images"
                          className=" rounded-circle"
                          style={{ height: "30px", width: "30px" }}
                        />
                      </div>
                    </div>
                    <div className="content">
                      <h6 className="m-0 themeBlue fw-sbold text-capitalize">
                        {groupDetails?.group_name || "--"}
                      </h6>
                    </div>
                  </div>
                  <Row>
                    <Col md="4" sm="6" className="my-2">
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 className="m-0 themeBlue fw-sbold">
                          {" "}
                          <span className="" style={{ color: "#3DA0AA" }}>
                            ■
                          </span>{" "}
                          Created At
                        </h6>
                        <p
                          className="m-0 themeBlue   pt-2"
                          style={{
                            fontWeight: "400",
                            fontSize: "small",
                            lineHeight: "18px",
                          }}
                        >
                          {convertToMomentDate(groupDetails?.createdAt)}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 className="m-0 themeBlue fw-sbold">
                          {" "}
                          <span className="" style={{ color: "#3DA0AA" }}>
                            ■
                          </span>{" "}
                          Start Date
                        </h6>
                        <p
                          className="m-0 themeBlue pt-2"
                          style={{
                            fontWeight: "400",
                            fontSize: "small",
                            lineHeight: "18px",
                          }}
                        >
                          {convertToMomentDate(groupDetails?.start_date)}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 className="m-0 themeBlue fw-sbold">
                          {" "}
                          <span className="" style={{ color: "#3DA0AA" }}>
                            ■
                          </span>{" "}
                          End Date
                        </h6>
                        <p
                          className="m-0 themeBlue pt-2 "
                          style={{
                            fontWeight: "400",
                            fontSize: "small",
                            lineHeight: "18px",
                          }}
                        >
                          {convertToMomentDate(groupDetails?.end_date)}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                        <h6 className="m-0 themeBlue fw-sbold">
                          {" "}
                          <span className="" style={{ color: "#3DA0AA" }}>
                            ■
                          </span>{" "}
                          Group Type
                        </h6>
                        <div className="d-flex gap-2 align-items-center">
                          <p
                            className="m-0 themeBlue pt-2"
                            style={{
                              fontWeight: "400",
                              fontSize: "small",
                              lineHeight: "18px",
                            }}
                          >
                            {CLIENT_TYPE[groupDetails?.group_type]}
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
                {!startSession && (
                  <Col lg="12" className="my-3">
                    <h6 className="m-0 themeBlue fw-sbold text-capitalize">
                      About {groupDetails?.group_name || "--"}
                    </h6>
                    <p
                      className="m-0 text-muted themeBlue pb-4 my-2"
                      style={{
                        fontWeight: "400",
                        fontSize: "small",
                        lineHeight: "18px",
                      }}
                    >
                      {groupDetails?.description || "--"}
                    </p>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
          {!startSession && (
            <>
              <Row>
                <Col lg="6" className="my-2">
                  <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                    <div className="left">
                      <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                        <li className="">
                          <h6 className="m-0 fw-bold themeBlue">Group List</h6>
                        </li>
                      </ul>
                    </div>
                    <div className="right">
                      <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                        <li className="">
                          <Button
                            onClick={() => setAddMemberModal(true)}
                            className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                          >
                            <span className="icn me-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="19"
                                viewBox="0 0 19 19"
                                fill="none"
                              >
                                <mask
                                  id="mask0_0_4440"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="19"
                                  height="19"
                                >
                                  <rect
                                    width="18.7197"
                                    height="18.7197"
                                    fill="#D9D9D9"
                                  />
                                </mask>
                                <g mask="url(#mask0_0_4440)">
                                  <path
                                    d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                    fill="white"
                                  />
                                </g>
                              </svg>
                            </span>{" "}
                            Add New Client
                          </Button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <TableLayout data={membersList || []} column={column} />
                  <CstmPagination
                    totalPages={totalMembers}
                    activePage={currentMemberPage}
                    handlePageChange={handleMemberPageChange}
                  />
                </Col>
              </Row>
            </>
          )}
          {startSession && (
            <>
              <Row>
                <Col
                  style={{
                    borderBottom: "1px solid #3da0aa4f",
                    borderTop: "1px solid #3da0aa4f",
                    padding: "1px",
                  }}
                  lg="12"
                  className="my-2"
                >
                  <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                    <ul className="list-unstyled ps-0 mb-0 d-flex w-100">
                      {[
                        "John Smith",
                        "John Smith",
                        "John Smith",
                        "John Smith",
                      ].map((name, index) => (
                        <li
                          key={index}
                          className="flex-grow-1"
                          style={{
                            width: "25%",
                            background: index === 0 ? "#b5b5b5" : "transparent",
                          }}
                        >
                          <Button
                            style={{
                              width: "100%",
                              height: "57px",
                              border: "0",
                              borderRadius: "0",
                            }}
                            variant="transparent"
                            className="d-flex align-items-center justify-content-center fw-sbold bg-transparent"
                          >
                            <span className="icn me-1 fw-sbold">{name}</span>
                          </Button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </Col>
              </Row>
              <Col lg="12" className="my-2">
                <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                  <div className="left">
                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                      <li className="d-flex  align-item-center">
                        <span
                          className="icn me-1 rounded-circle  p-2"
                          style={{ background: "#FBD2EF" }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="23"
                            height="21"
                            viewBox="0 0 23 21"
                            fill="none"
                          >
                            <path
                              d="M16.2087 0.924316C15.1765 0.940372 14.1668 1.22852 13.2816 1.75965C12.3963 2.29078 11.6669 3.0461 11.167 3.94932C10.6671 3.0461 9.93773 2.29078 9.0525 1.75965C8.16728 1.22852 7.15758 0.940372 6.12537 0.924316C4.4799 0.995808 2.9296 1.71563 1.81317 2.92653C0.69674 4.13743 0.104931 5.74096 0.167035 7.38682C0.167035 11.5549 4.5542 16.1071 8.2337 19.1935C9.05524 19.8839 10.0939 20.2623 11.167 20.2623C12.2401 20.2623 13.2788 19.8839 14.1004 19.1935C17.7799 16.1071 22.167 11.5549 22.167 7.38682C22.2291 5.74096 21.6373 4.13743 20.5209 2.92653C19.4045 1.71563 17.8542 0.995808 16.2087 0.924316ZM12.9225 17.791C12.4311 18.2047 11.8094 18.4316 11.167 18.4316C10.5247 18.4316 9.90297 18.2047 9.41162 17.791C4.70179 13.8392 2.00037 10.0479 2.00037 7.38682C1.93771 6.22697 2.3362 5.0894 3.10895 4.22221C3.8817 3.35501 4.966 2.82855 6.12537 2.75765C7.28474 2.82855 8.36904 3.35501 9.14179 4.22221C9.91453 5.0894 10.313 6.22697 10.2504 7.38682C10.2504 7.62993 10.3469 7.86309 10.5189 8.035C10.6908 8.20691 10.9239 8.30348 11.167 8.30348C11.4102 8.30348 11.6433 8.20691 11.8152 8.035C11.9871 7.86309 12.0837 7.62993 12.0837 7.38682C12.021 6.22697 12.4195 5.0894 13.1923 4.22221C13.965 3.35501 15.0493 2.82855 16.2087 2.75765C17.3681 2.82855 18.4524 3.35501 19.2251 4.22221C19.9979 5.0894 20.3964 6.22697 20.3337 7.38682C20.3337 10.0479 17.6323 13.8392 12.9225 17.7873V17.791Z"
                              fill="#071E3E"
                            />
                          </svg>
                        </span>
                        <h6 className="m-0 fw-bold themeBlue p-2">
                          Treatment Plan
                        </h6>
                        <span
                          className="icn me-1 rounded-circle p-2 shadow-lg"
                          style={{ background: "#fff" }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_6771_42318)">
                              <path
                                d="M14.5488 9.07964C14.134 9.07964 13.7988 9.4157 13.7988 9.82959V15.8296C13.7988 16.2429 13.4628 16.5796 13.0489 16.5796H2.54883C2.13479 16.5796 1.79887 16.2429 1.79887 15.8296V5.32959C1.79887 4.91636 2.13479 4.57964 2.54883 4.57964H8.54887C8.96361 4.57964 9.29883 4.24361 9.29883 3.82968C9.29883 3.41565 8.96361 3.07959 8.54887 3.07959H2.54883C1.30834 3.07959 0.298828 4.0891 0.298828 5.32959V15.8296C0.298828 17.0702 1.30834 18.0796 2.54883 18.0796H13.0489C14.2894 18.0796 15.2989 17.0702 15.2989 15.8296V9.82959C15.2989 9.41489 14.9635 9.07964 14.5488 9.07964Z"
                                fill="#818181"
                              />
                              <path
                                d="M7.3308 8.39625C7.27868 8.44861 7.24298 8.51506 7.22808 8.58743L6.69785 11.2395C6.67314 11.3624 6.71212 11.4892 6.80058 11.5784C6.83548 11.6132 6.8769 11.6408 6.92247 11.6596C6.96804 11.6784 7.01686 11.688 7.06615 11.6879C7.09005 11.6879 7.11491 11.6857 7.13962 11.6805L9.7909 11.1503C9.86437 11.1352 9.9311 11.1 9.98289 11.0474L15.9169 5.11339L13.2656 2.46226L7.3308 8.39625ZM17.7498 0.628542C17.0187 -0.102743 15.8291 -0.102743 15.0985 0.628542L14.0606 1.66646L16.7119 4.31773L17.7498 3.27967C18.1038 2.92646 18.2989 2.4554 18.2989 1.95442C18.2989 1.45345 18.1038 0.982425 17.7498 0.628542Z"
                                fill="#818181"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_6771_42318">
                                <rect
                                  width="18"
                                  height="18"
                                  fill="white"
                                  transform="translate(0.298828 0.0449219)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="right">
                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                      <li className="">
                        <Link
                          to={""}
                          className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                        >
                          <span className="icn me-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="19"
                              height="19"
                              viewBox="0 0 19 19"
                              fill="none"
                            >
                              <mask
                                id="mask0_0_4440"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="19"
                                height="19"
                              >
                                <rect
                                  width="18.7197"
                                  height="18.7197"
                                  fill="#D9D9D9"
                                />
                              </mask>
                              <g mask="url(#mask0_0_4440)">
                                <path
                                  d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                  fill="white"
                                />
                              </g>
                            </svg>
                          </span>
                          Add New Goal
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <TableLayout data={data} column={newColumn} url={""} />
              </Col>
              <Col className="my-2" lg="12">
                <div
                  className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                //   style={{ borderTop: "1px solid #41a2a84d" }}
                >
                  <Button className="d-flex align-items-center justify-content-center commonBtn">
                    Next
                  </Button>
                </div>
              </Col>
            </>
          )}
        </Container>}
      </section>
    </>
  );
};

export default GroupDetail;
